import React, { useState } from 'react';
import { FAQ, COLORS } from '../../data/siteData';
import { ChevronDown } from 'lucide-react';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-20" style={{ backgroundColor: COLORS.background }}>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4" style={{ color: COLORS.dark }}>
            {FAQ.title}
          </h2>
          <p className="text-lg" style={{ color: COLORS.gray }}>
            {FAQ.subtitle}
          </p>
        </div>

        <div className="space-y-4">
          {FAQ.items.map((item, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl shadow-sm overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-50 transition-colors"
                data-testid={`faq-item-${index}`}
              >
                <span className="text-base font-medium pr-4" style={{ color: COLORS.dark }}>
                  {item.question}
                </span>
                <ChevronDown 
                  className={`w-5 h-5 flex-shrink-0 transition-transform duration-300 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                  style={{ color: COLORS.gray }}
                />
              </button>
              <div 
                className={`px-6 overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'pb-5 max-h-96' : 'max-h-0'
                }`}
              >
                <p className="text-sm leading-relaxed" style={{ color: COLORS.gray }}>
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
